import { Skeleton } from '@/shared/components/shadcn/skeleton';

export function CreatorCardSkeleton() {
  return (
    <div className="border-border bg-card overflow-hidden rounded-lg border">
      {/* Card Header with Checkbox */}
      <div className="flex items-start gap-3 p-4">
        {/* Profile Info Skeleton */}
        <div className="flex flex-1 items-start gap-3">
          {/* Avatar skeleton */}
          <Skeleton className="bg-muted h-12 w-12 rounded-full" />

          <div className="flex-1">
            {/* Name skeleton */}
            <Skeleton className="bg-muted mb-2 h-5 w-30 rounded-sm" />

            {/* Stats skeleton */}
            <div className="flex gap-3">
              <Skeleton className="bg-muted h-4 w-15 rounded-sm" />
              <Skeleton className="bg-muted h-4 w-15 rounded-sm" />
              <Skeleton className="bg-muted h-4 w-15 rounded-sm" />
            </div>
          </div>
        </div>
      </div>

      {/* Content Images Skeleton - Match real card height */}
      <div className="px-4 pb-3">
        <div className="flex gap-2">
          <Skeleton className="bg-muted h-90 w-52 rounded-sm" />
          <Skeleton className="bg-muted h-90 w-52 rounded-sm" />
          <Skeleton className="bg-muted h-90 w-52 rounded-sm" />
          <Skeleton className="bg-muted h-90 w-52 rounded-sm" />
        </div>
      </div>

      {/* Attributes Skeleton */}
      <div className="flex flex-wrap gap-1.5 px-4 pb-4">
        <Skeleton className="bg-muted h-6 w-20 rounded-full" />
        <Skeleton className="bg-muted h-6 w-25 rounded-full" />
        <Skeleton className="bg-muted h-6 w-22.5 rounded-full" />
      </div>
    </div>
  );
}
